import type {
  ChannelResponse,
  ChannelSummary,
  CreateChannelRequest,
  ManageChannelResponse,
  UpdateChannelRequest,
} from '@pulsify/shared'
import { api, getAuthToken, unwrap } from '~/shared/lib/rpc'

/** The business's own organizer or venue page (its channel) as the dashboard edits it. */
export const organizerApi = {
  async get(businessId: string, channelId?: string): Promise<ManageChannelResponse['channel']> {
    const res = await api.api.channels.manage.$get({
      query: channelId ? { businessId, channelId } : { businessId },
    })
    return (await unwrap<ManageChannelResponse>(res)).channel
  },

  async create(input: CreateChannelRequest): Promise<ChannelSummary> {
    const res = await api.api.channels.$post({ json: input })
    return (await unwrap<ChannelResponse>(res)).channel
  },

  async update(id: string, patch: UpdateChannelRequest): Promise<ChannelSummary> {
    const res = await api.api.channels[':id'].$patch({ param: { id }, json: patch })
    return (await unwrap<ChannelResponse>(res)).channel
  },

  async setPublished(id: string, published: boolean): Promise<ChannelSummary> {
    const res = await api.api.channels[':id'].published.$put({
      param: { id },
      json: { published },
    })
    return (await unwrap<ChannelResponse>(res)).channel
  },

  async uploadPicture(id: string, slot: 'avatar' | 'cover', file: File): Promise<ChannelSummary> {
    const url = api.api.channels[':id'].picture[':slot'].$url({ param: { id, slot } })
    const body = new FormData()
    body.append('file', file)
    const token = await getAuthToken()
    const res = await fetch(url, {
      method: 'POST',
      body,
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    })
    return (await unwrap<ChannelResponse>(res)).channel
  },
}
